import React from "react";
import { Nav, NavLink, NavModule, NavSplit } from "./styles";
// import MobileApps from "./MobileApps";
import ShipTo from "./ShipTo";
import Language from "./Language";
import { CUSTOMER_SERVICE } from "../../utils";
import getLangKeyValueFun from "utils/lang";
import langGroup from "assets/lang.json";
import { CountryInfo, CurrencyInfo } from "headFootServices/header/header";

const getText = getLangKeyValueFun(langGroup);

export interface HeaderNavProps {
	/** not top, 全部国家/地区 */
	countries: CountryInfo[];
	/** top country */
	popularCounties: CountryInfo[];
	/** 用户当前国家/地区 */
	userCountry: CountryInfo;
	/** 全部货币 */
	currencies: CurrencyInfo[];
	/** 用户当前货币 */
	userCurrency: CurrencyInfo;
	/** 全部语言 */
	languages: any[];
	/** 用户当前语言 */
	userLanguage: any;
	onChangeLanguage?: (lan?: string) => void;
	/** 低价APP 30%折扣应用国家 */
	lowPriceCountryPriceOff: string;
}

class HeaderNav extends React.Component<HeaderNavProps> {
	/** 新页面打开顾客服务页 */
	onOpenCustomerService = () => {
		window.open(CUSTOMER_SERVICE());
	};

	render() {
		const {
			countries = [],
			userCountry,
			currencies = [],
			userCurrency,
			popularCounties = [],
			languages = [],
			userLanguage,
			onChangeLanguage,
			// lowPriceCountryPriceOff,
		} = this.props;
		return (
			<Nav>
				{/* <MobileApps lowPriceCountryPriceOff={lowPriceCountryPriceOff} /> */}
				<NavSplit />
				<NavModule>
					<NavLink href={CUSTOMER_SERVICE()} target="_blank" style={{ marginRight: 4 }}>
						{getText("Help Center")}
					</NavLink>
				</NavModule>
				<NavSplit />
				<ShipTo
					countries={countries}
					popularCounties={popularCounties}
					userCountry={userCountry}
					currencies={currencies}
					userCurrency={userCurrency}
				/>
				<NavSplit style={{ marginRight: 18, marginLeft: 14 }} />
				<Language
					languages={languages}
					userLanguage={userLanguage}
					onChangeLanguage={onChangeLanguage}
				/>
			</Nav>
		);
	}
}

export default HeaderNav;
